// Re-export the new separate components for backward compatibility
export { PreviewProvider as OptimizedPreviewProvider, usePreview } from './PreviewProvider';

// Import usePreview to use it in the legacy hook
import { usePreview } from './PreviewProvider';

// Re-export hook with legacy name and backward compatibility
export const useOptimizedPreview = () => {
  const context = usePreview();

  return {
    ...context,
  };
};
